/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1043);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1043:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var checkBrowser = __webpack_require__(1044);
checkBrowser({
	'Chrome': 57,
	'Safari': 11,
	'Firefox': 52,
	'Opera': 44,
	'IE': 11,
	'Edge': 16,
	'Chrome Mobile': 0,
	'Safari Mobile': 0,
	'Firefox Mobile': 0,
	'Samsung Browser': 0,
	'UC Browser': 0,
	'Edge Mobile': 0
});

/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

module.exports = function (config) {
    if (typeof config !== 'object') {
        throw new Error('Invalid configuration format');
    }

    var supportedBrowsers = {};
    var supportedBrowsersString = [];
    for (var browser in config) {
        if (!/^(Chrome|Safari|Opera|Firefox|IE|Edge|Chrome Mobile|Safari Mobile|Edge Mobile|Firefox Mobile|Samsung Browser|UC Browser)$/.test(browser)) {
            throw new Error('Unknown browser in configuration: ' + browser);
        }

        var version = parseInt(config[browser]);
        supportedBrowsers[browser] = version;
        supportedBrowsersString.push(browser + ' ' + version + '+');
    }
    supportedBrowsersString = supportedBrowsersString.join(', ');

    function isSupported(ua) {
        var versionMatch;

        if (/Mobi|Tablet|Android|iPhone|iPad|iPod/.test(ua)) {
            // Firefox Mobile on iOS or Android
            // on iOS it pretends to be Safari because it uses WebKit not Gecko
            versionMatch = ua.match(/Firefox\/(\d*)/) || ua.match(/FxiOS\/(\d*)/);
            if (typeof supportedBrowsers['Firefox Mobile'] !== 'undefined' && 
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Firefox Mobile']) {
                return true;
            }

            // Edge Mobile on iOS or Android
            // pretends to be Safari and Chrome
            versionMatch = ua.match(/EdgiOS\/(\d*)/) || ua.match(/EdgA\/(\d*)/);
            if (typeof supportedBrowsers['Edge Mobile'] !== 'undefined' && 
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Edge Mobile']) {
                return true;
            }

            // Samsung Browser on Android
            // pretends to be Chrome and Safari
            versionMatch = ua.match(/SamsungBrowser\/(\d*)/);
            if (typeof supportedBrowsers['Samsung Browser'] !== 'undefined' && 
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Samsung Browser']) {
                return true;
            }

            // UC Browser on Android and iOS
            // pretends to be Chrome and Safari
            versionMatch = ua.match(/UCBrowser\/(\d*)/);
            if (typeof supportedBrowsers['UC Browser'] !== 'undefined' && 
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['UC Browser']) {
                return true;
            }

            // Safari Mobile
            versionMatch = ua.match(/Version\/(\d*)/);
            if (typeof supportedBrowsers['Safari Mobile'] !== 'undefined' &&
                /Safari/.test(ua) && /Mobile/.test(ua) && 
                !/Chrome/.test(ua) && !/EdgiOS/.test(ua) && !/EdgA/.test(ua) && !/FxiOS/.test(ua) && !/Samsung/i.test(ua) && !/UCBrowser/.test(ua) &&
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Safari Mobile']) {
                return true;
            }

            // Chrome Mobile on Android
            // pretends to be Safari Mobile
            versionMatch = ua.match(/Chrome\/(\d*)/);
            if (typeof supportedBrowsers['Chrome Mobile'] !== 'undefined' &&
                /Safari/.test(ua) && /Chrome/.test(ua) && !/EdgiOS/.test(ua) && !/EdgA/.test(ua) && !/Samsung/i.test(ua) && !/UCBrowser/.test(ua) &&
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Chrome Mobile']) {
                return true;
            }

            // Chrome Mobile on iOS
            // pretends to be Safari Mobile
            versionMatch = ua.match(/CriOS\/(\d*)/);
            if (typeof supportedBrowsers['Chrome Mobile'] !== 'undefined' &&
                /Safari/.test(ua) && /CriOS/.test(ua) &&  
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Chrome Mobile']) {
                return true;
            }

        } else {

            // IE 11
            // pretends to be like Gecko
            if (typeof supportedBrowsers['IE'] !== 'undefined' &&
                supportedBrowsers['IE'] <= 11 && /rv:11/.test(ua)) {
                return true;
            }

            // IE 10-
            versionMatch = ua.match(/MSIE ([\d\.]*);/);
            if (typeof supportedBrowsers['IE'] !== 'undefined' && 
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['IE']) {
                return true;
            }

            // Edge
            // pretends to be Safari and Chrome
            versionMatch = ua.match(/Edge\/(\d*)/);
            if (typeof supportedBrowsers['Edge'] !== 'undefined' && 
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Edge']) {
                return true;
            }

            // Firefox
            versionMatch = ua.match(/Firefox\/(\d*)/);
            if (typeof supportedBrowsers['Firefox'] !== 'undefined' && 
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Firefox']) {
                return true;
            }

            // Opera 15+
            // pretends to be Safari and Chrome
            versionMatch = ua.match(/OPR\/(\d*)/);
            if (typeof supportedBrowsers['Opera'] !== 'undefined' &&
                supportedBrowsers['Opera'] >= 15 && 
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Opera']) {
                return true;
            }

            // Opera 12-
            versionMatch = ua.match(/Opera\/(\d*)/);
            if (typeof supportedBrowsers['Opera'] !== 'undefined' &&
                supportedBrowsers['Opera'] <= 12 && 
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Opera']) {
                return true;
            }

            // Safari
            versionMatch = ua.match(/Version\/(\d*)/);
            if (typeof supportedBrowsers['Safari'] !== 'undefined' &&
                /Safari/.test(ua) && !/Chrome/.test(ua) && !/Edge/.test(ua) && !/OPR/.test(ua) &&
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Safari']) {
                return true;
            }

            // Chrome
            // pretends to be Safari
            versionMatch = ua.match(/Chrome\/(\d*)/);
            if (typeof supportedBrowsers['Chrome'] !== 'undefined' &&
                /Safari/.test(ua) && /Chrome/.test(ua) && !/Edge/.test(ua) && !/OPR/.test(ua) && 
                versionMatch && parseInt(versionMatch[1]) >= supportedBrowsers['Chrome']) {
                return true;
            }
        }
        
        return false;                    
    }

    var isBrowserSupported = isSupported(navigator.userAgent);     

    window.addEventListener('load', function () {
        if (!isBrowserSupported) {
            alert('Some functionalities on this website may not work with your current browser. Supported browsers are: ' + supportedBrowsersString);
        }
    });

    return isBrowserSupported;
}

/***/ })

/******/ });


// WEBPACK FOOTER //
// support.js